import React, { Suspense } from "react";
import { useFormik } from "formik";
import { Modal } from "react-bootstrap";
import { Checkbox, Input } from "@mobiscroll/react5";
import Loader from "src/components/Dashboard/common/Loader";
import { rejectClinicCreationRequest } from "./api";
import * as Yup from "yup";

const initialValues = {
  clinicNameVerified: false,
  nameVerified: false,
  registrationNumberVerified: false,
  bankDetailsVerified: false,
  message: "",
};
const initialTouched = {
  clinicNameVerified: false,
  nameVerified: false,
  registrationNumberVerified: false,
  bankDetailsVerified: false,
  message: false,
};

const validationSchema = Yup.object().shape({
  clinicNameVerified: Yup.boolean().required("Required"),
  nameVerified: Yup.boolean().required("Required"),
  registrationNumberVerified: Yup.boolean().required("Required"),
  bankDetailsVerified: Yup.boolean().required("Required"),
  message: Yup.string().min(3, "Too short!").required("Required"),
});

const RejectionPopup = ({ closeRejectionPopup, rejectionPopup, params, value, setReload, }) => {

  const {
    values, touched, errors,
    handleSubmit, handleChange, handleBlur,
    setFieldValue, handleReset, isValid,
  } = useFormik({
    initialValues,
    initialTouched,
    
    onSubmit: async (values) => {
      setLoader(true);

      let data = { requestId: params.value, ...values };
      const { roles, ...rest } = data;
      console.log("data-->", rest);

      if (value != "NA") {
        data.roles = value;
      }

      const res = await rejectClinicCreationRequest(rest);
      if (res) {
        setReload(true);
      }
      setLoader(false);
      closeRejectionPopup();
    },
    validationSchema,
  });
  const [loader, setLoader] = React.useState(false);

  const handleCheckboxChange = (e) => {
    console.log(e);
    setFieldValue(e.target.name, e.target.checked, true);
  };

  return (
    <>
      <Loader show={loader} />
      <Modal
        show={rejectionPopup}
        onHide={closeRejectionPopup}
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <Suspense fallback={<div>Loading...</div>}>
            <form action="" method="post" onSubmit={handleSubmit}>
              <div className="mbsc-row mb-2">
                <div className="mbsc-col-12">
                  <div className="custom-repeat-checkbox-cont">
                    <Checkbox
                      name="clinicNameVerified"
                      onChange={handleCheckboxChange}
                      checked={values?.clinicNameVerified}
                      error={true}
                      errorMessage={"ERror"}
                    >
                      Clinic Name Verified
                    </Checkbox>
                    <div className="mbsc-ios mbsc-error-message">
                      {touched?.clinicNameVerified && errors?.clinicNameVerified
                        ? errors?.clinicNameVerified
                        : null}
                    </div>
                  </div>
                </div>
                <div className="mbsc-col-12">
                  <div className="custom-repeat-checkbox-cont">
                    <Checkbox
                      name="nameVerified"
                      onChange={handleCheckboxChange}
                      checked={values?.nameVerified}
                    >
                      User Name Verified
                    </Checkbox>
                    <div className="mbsc-ios mbsc-error-message">
                      {touched?.nameVerified && errors?.nameVerified
                        ? errors?.nameVerified
                        : null}
                    </div>
                  </div>
                </div>
                <div className="mbsc-col-12">
                  <div className="custom-repeat-checkbox-cont">
                    <Checkbox
                      name="registrationNumberVerified"
                      onChange={handleCheckboxChange}
                      checked={values?.registrationNumberVerified}
                    >
                      Medical Registration Number Verified
                    </Checkbox>
                    <div className="mbsc-ios mbsc-error-message">
                      {touched?.registrationNumberVerified &&
                        errors?.registrationNumberVerified
                        ? errors?.registrationNumberVerified
                        : null}
                    </div>
                  </div>
                </div>
                <div className="mbsc-col-12">
                  <div className="custom-repeat-checkbox-cont">
                    <Checkbox
                      name="bankDetailsVerified"
                      onChange={handleCheckboxChange}
                      checked={values?.bankDetailsVerified}
                    >
                      Banking Details Verified
                    </Checkbox>
                    <div className="mbsc-ios mbsc-error-message">
                      {touched?.bankDetailsVerified &&
                        errors?.bankDetailsVerified
                        ? errors?.bankDetailsVerified
                        : null}
                    </div>
                  </div>
                </div>
                <div className="mbsc-col-12">
                  <Input
                    label="Message*"
                    name="message"
                    type="text"
                    inputStyle="underline"
                    labelStyle="floating"
                    placeholder=""
                    error={touched?.message && errors?.message}
                    errorMessage={errors?.message}
                    value={values?.message}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>

                <div className="mbsc-col-12 mt-3 d-flex flex-row justify-content-center">
                  <button
                    type="button"
                    onClick={closeRejectionPopup}
                    className="docg-patient-cancel-btn mr-2"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="docg-save-btn">
                    Reject
                  </button>
                </div>
              </div>
            </form>
          </Suspense>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RejectionPopup;
